import { useState } from 'react';
import { Link } from 'react-router-dom';
import { TopNav } from '../components/TopNav';
import { Footer } from '../components/Footer';

const ANSWERS = ['A suspicious casserole.', 'Unexpected jazz hands.', 'A disappointing plot twist.'];

export default function LandingPage() {
  const [selected, setSelected] = useState<number | null>(null);
  return <>
    <TopNav />
    <main className="landing-room">
      <section className="landing-intro">
        <p className="table-eyebrow">Good company. Questionable answers.</p>
        <h1>Deck After Dark</h1>
        <p className="landing-description">Make a bad sentence better. Play your funniest card, win over the judge, and give your friends something to bring up tomorrow.</p>
        <div className="landing-actions">
          <Link to="/create" data-testid="nav-create" className="table-button">Create Room <span aria-hidden="true">↗</span></Link>
          <Link to="/join" data-testid="nav-join" className="table-button table-button-outline">Join Room</Link>
        </div>
        <p className="landing-details">Play in your browser · Bring your friends · Adult card content</p>
      </section>
      <section className="sample-table" aria-labelledby="sample-title">
        <div className="sample-heading"><h2 id="sample-title">Get a feel for it.</h2><span>One prompt. Your best answer.</span></div>
        <div className="sample-prompt">
          <span className="table-eyebrow">The black card / Pick 1</span>
          <p>The highlight of my weekend was <span className="sample-answer" aria-live="polite">{selected === null ? '_________.' : ANSWERS[selected]}</span></p>
        </div>
        <p className="sample-instruction">Pick a white card to finish the sentence.</p>
        <div className="sample-hand">
          {ANSWERS.map((answer, index) => <button key={answer} type="button" aria-pressed={selected === index} onClick={() => setSelected(index)} className="sample-card">
            <span>{answer}</span><span className="sample-card-footer">{selected === index ? '✓ Your pick' : `0${index + 1} / Answer`}</span>
          </button>)}
        </div>
        <p className="sample-caption">In a real round, the judge picks their favorite. No right answers. Just their taste.</p>
      </section>
      <section id="how-it-works" className="table-rules" aria-label="How it works">
        <div><span className="table-eyebrow">01 / Get together</span><h2>Make room for everyone.</h2><p>Create a room and share the code. Friends join on their own phones or computers.</p></div>
        <div><span className="table-eyebrow">02 / Play your hand</span><h2>Find the wrong answer.</h2><p>Read the prompt and choose your cards. For a Pick 2, select them in the order you want them read.</p></div>
        <div><span className="table-eyebrow">03 / Read it out</span><h2>Let the table decide.</h2><p>The judge chooses a winner, who earns a point. The judge changes each round.</p></div>
      </section>
      <Link to="/how-to-play" className="full-rules-link">Read the full rules →</Link>
    </main>
    <Footer />
  </>;
}
